export const DEFAULT_ORDER_BY = 'capCategory'
export const DEFAULT_ORDER: 'asc' | 'desc' = 'desc'
